const useForm = async(formId: string): Promise<object> => {
  const {data: form} = await useAsyncData(formId, () => {
    return queryCollection("forms").where("formId", "=", formId).first();
  });

  return form?.value?.body || {};
}

export default useForm;
  